import React from 'react';
import ReactDOM from 'react-dom/client';

import { ErrorBoundary, initReactObservability } from '@tt/observability/react';
import { SharedErrorPage } from '@tt/utils';

import config from './utilities/config';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LogoImg from './resources/images/Logo.svg';

import './index.scss';
import './tailwind.css';

const { version } = require('../package.json');

const phantomPattern = new RegExp(`^${config.get('PHANTOM_BASE_URL')}/.*`);
const journalBackendPattern = new RegExp(`^${config.get('BASE_API_URL')}/.*`);

initReactObservability({
    service: '@apps/trading-journal-frontend',
    version,
    dsn: config.get('SENTRY_DSN'),
    environment: config.get('SENTRY_ENVIRONMENT') || config.get('NODE_ENV') || process.env.NODE_ENV,
    tracesSampleRate: parseFloat(config.get('SENTRY_TRACES_SAMPLE_RATE') || '0.1'),
    tracePropagationTargets: ['localhost', phantomPattern, journalBackendPattern],
    replaysSessionSampleRate: parseFloat(
        config.get('SENTRY_REPLAYS_SESSION_SAMPLE_RATE') || '0.025'
    ),
    replaysOnErrorSampleRate: parseFloat(config.get('SENTRY_REPLAYS_ERROR_SAMPLE_RATE') || '0.01')
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ErrorBoundary
            fallback={({ resetError }) => (
                <SharedErrorPage
                    appName="Journal"
                    homeHref="/"
                    logoSrc={LogoImg}
                    logoAlt="Trading Journal"
                    logoWidth={198}
                    onPrimaryAction={resetError}
                />
            )}
        >
            <App />
        </ErrorBoundary>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
